


















































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import axios, { AxiosRequestConfig, AxiosProxyConfig, AxiosResponse, AxiosError } from 'axios'

@Component
export default class Entrance extends Vue {
  num: string = ''
  uid: string = ''
  uname: string = ''
  noticeMsg: string = ''
  isIn: boolean = false
  inMsg: string = 'ようこそ！'
  outMsg: string = '気をつけて帰ってね！'
  statusIn: string = 'in'
  statusOut: string = 'out'
  isEntranceResult: boolean = false
  defaultTemperature: string = '30.0'
  temperature: string = this.defaultTemperature
  errorMessage = {
    notFound: '生徒が見つかりません',
    system: 'システムでエラーが発生しました'
  }

  private clickInit () {
    this.uid = ''
    this.uname = ''
    this.isEntranceResult = false
    this.temperature = this.defaultTemperature
    this.getCustom()
  }

  private getCustom () {
    let self = this
    let params = new URLSearchParams()
    params.append('token', self.$store.state.entranceApiToken)

    axios({
      method: 'POST',
      url: process.env.VUE_APP_ENTRANCE_API + '/get/custom',
      timeout: 10000,
      data: params
    })
      .then(response => {
        if (response.status === 200 && response.data.result === 'ok' && Object.keys(response.data.value).length !== 0) {
          let customs = response.data.value.customs
          if (customs === undefined || customs === null) {
            return
          }
          if (customs.msg !== undefined) {
            this.noticeMsg = customs.msg.user_text
          }
          if (customs.check_in !== undefined) {
            this.inMsg = customs.check_in.user_text
          }
          if (customs.checkout !== undefined) {
            this.outMsg = customs.checkout.user_text
          }
        }
      })
      .catch(error => {
        console.log(error)
        this.showError(true)
      })
  }

  private clickNum (val: string) {
    if (this.uname !== '') return

    this.uid += val
    if (this.$store.state.isTakeda) {
      if (this.uid.length > 8) {
        this.clickInit()
      }
    } else if (this.$store.state.isCkc) {
      if (this.uid.length > 7) {
        this.clickInit()
      }
    } else {
      if (this.uid.length > 4) {
        this.clickInit()
      }
    }

    this.num = val
    let self = this
    setTimeout(function () {
      self.num = ''
    }, 100)
  }

  private clickNumTemp (val: string) {
    if (this.uname === '') return

    if (this.temperature.length === 2) {
      this.temperature += '.' + val
    } else if (this.temperature.length >= 4) {
      this.temperature = '3' + val
    }

    this.num = val
    let self = this
    setTimeout(function () {
      self.num = ''
    }, 100)
  }

  private clickEnter () {
    if (this.uid === '') return
    let params = new URLSearchParams()
    params.append('token', this.$store.state.entranceApiToken)
    params.append('lid', this.uid)

    axios({
      method: 'POST',
      url: process.env.VUE_APP_ENTRANCE_API + '/get/user2',
      timeout: 10000,
      data: params
    })
      .then(response => {
        if (response.status === 200 && response.data.result === 'ok' && Object.keys(response.data.value).length !== 0) {
          this.uname = response.data.value.name
          this.isIn = response.data.value.checkin
        } else {
          this.$swal({
            icon: 'error',
            title: this.errorMessage.notFound,
            showConfirmButton: false,
            timer: 1200
          })
          this.clickInit()
        }
      })
      .catch(error => {
        console.log(error)
        this.showError()
      })
  }

  private async checkIn () {
    if (await this.updateEntranceStatus(this.statusIn)) {
      this.$swal({
        icon: 'success',
        title: this.inMsg,
        showConfirmButton: false,
        timer: 2000
      })
    } else {
      this.showError()
    }

    this.clickInit()
  }

  private async checkOut () {
    if (await this.updateEntranceStatus(this.statusOut)) {
      this.$swal({
        icon: 'success',
        title: this.outMsg,
        showConfirmButton: false,
        timer: 2000
      })
    } else {
      this.showError()
    }

    this.clickInit()
  }

  private async updateEntranceStatus (status: string) : Promise<boolean> {
    if (this.uid === '') {
      return false
    }
    let self = this
    let params = new URLSearchParams()
    params.append('status', status)
    params.append('lid', this.uid)
    if (this.$store.state.isSettingTemperature && status === this.statusIn) {
      params.append('temp', this.temperature)
    }
    params.append('token', self.$store.state.entranceApiToken)

    await axios({
      method: 'POST',
      url: process.env.VUE_APP_ENTRANCE_API + '/set/user',
      timeout: 10000,
      data: params
    })
      .then(response => {
        if (response.status === 200 && response.data.result === 'ok') {
          self.isEntranceResult = true
        } else {
          self.isEntranceResult = false
        }
      })
      .catch(error => {
        self.isEntranceResult = false
        console.log(error)
      })

    return self.isEntranceResult
  }

  logErrors (promise: any) {
    promise.catch(console.error)
  }

  private showError (isLogout: boolean = false) {
    this.$swal({
      icon: 'error',
      title: this.errorMessage.system,
      showConfirmButton: false,
      timer: 2000
    })

    if (isLogout) {
      this.$router.push({ name: 'logout' })
    } else {
      this.reload()
    }
  }

  private reload () {
    this.$router.go(0)
  }

  public onKeydown (e: any) {
    let keyCode = e.key
    if (Number(keyCode) !== Number.NaN && (Number(keyCode) >= 0 && Number(keyCode) <= 9)) {
      if (this.uname === '') {
        this.clickNum(keyCode)
      } else {
        this.clickNumTemp(keyCode)
      }
    } else if (keyCode === 'Enter') {
      if (this.uname === '') {
        this.clickEnter()
      } else {
        if (this.isIn) {
          this.checkOut()
        } else {
          this.checkIn()
        }
      }
    } else if (keyCode === 'Backspace') {
      if (this.uid.length > 0 && this.uname === '') {
        let uid = this.uid
        this.uid = uid.slice(0, -1)
      }
    } else if (keyCode === 'Escape' || keyCode === 'Delete') {
      this.clickInit()
    }
  }

  private toEntranceQr () {
    let self = this
    if (self.$route.path !== '/qr') {
      self.$router.push({ name: 'qr' })
    }
  }

  get refs (): any {
    return this.$refs
  }

  created () {
    this.clickInit()
  }

  mounted () {
    window.addEventListener('keydown', this.onKeydown, false)
  }

  beforeDestroy () {
    window.removeEventListener('keydown', this.onKeydown, false)
  }
}
